export function getTimeRange(
  timestamp: string,
  minutes: number
): { startDate: string; endDate: string } {
  const normalized = timestamp.replace(" ", "_").replace(/:/g, "-");

  const [datePart, timePart] = normalized.split("_");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split("-").map(Number);

  const baseDate = new Date(year, month - 1, day, hour, minute, second);

  const startDate = new Date(baseDate.getTime() - minutes * 60 * 1000);
  const endDate = new Date(baseDate.getTime() + minutes * 60 * 1000);

  const formatDate = (d: Date): string => {
    const pad = (n: number) => String(n).padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
  };

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
}
